<template>
    <div
        class="col-span-12 lg:col-span-6 p-5 flex flex-col justify-between bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 md:rounded-lg relative md:min-h-[400px]"
    >
        <div
            class="absolute inset-0 flex flex-col items-center justify-center gap-2 lg:gap-4 mt-44 sm:mt-24 md:mt-20 lg:mt-36 pb-4 lg:pb-2"
        >
            <div class="text-center text-xl sm:text-xl md:text-1xl lg:text-2xl">
                <h1 class="text-black dark:text-gray-100 font-bold">Become a travel</h1>
                <h1 class="text-[var(--Primary-10x-Orange,#FD421D)] font-bold">
                    rewards genius
                </h1>
            </div>
            <p
                class="text-sm sm:text-sm md:text-sm lg:text-sm text-slate-500 dark:text-slate-400 text-center px-4"
            >
                Join our free course to learn a step-by-step guide on how to
                travel the world for next to nothing.
            </p>
            <a
                href="/course"
                class="btn-base btn-10x-orange"
                id="hs-dashboard-start-course"
            >
                Get started for free
            </a>
        </div>
        <icon icon="tx-courses" svgClass="m-auto w-full" />
    </div>
</template>
<script setup>
import Icon from '@/components/ui/icon/icon-courses.vue';
</script>
